<template>
    <div class="w-100">
        <!-- Page title -->
        <div class="row align-items-center mt-1 mb-3">
            <div class="col-9">
                <h2 class="page-title">
                    {{ pageTitle }}
                </h2>
            </div>
            <!-- Progress bar -->
            <div v-if="progressBar == true" class="col-3 ms-auto d-print-none d-flex align-items-center" id="progressBar">
                <span class="small me-3 w-50 text-end">{{ percentageComplete }}% Complete</span>
                <b-progress class="w-50" :value="currentStep" :max="maxStep" animated></b-progress>
            </div>
        </div>

        <!-- Alert box -->
        <div v-if="this.v$.step[this.currentStep - 1].$error" class="alert alert-danger alert-dismissible" role="alert">
            <div class="d-flex">
                <div>
                    <!-- Download SVG icon from http://tabler-icons.io/i/alert-circle -->
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon alert-icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                        <path d="M12 8v4"></path>
                        <path d="M12 16h.01"></path>
                    </svg>
                </div>
                <div>
                    <span v-if="v$.$errors.length > 1"> Sorry, there are ({{ this.v$.step[this.currentStep - 1].$errors.length }}) errors found please correct the errors to proceed.</span>
                    <span v-if="v$.$errors.length <= 1"> Sorry, there's ({{ this.v$.step[this.currentStep - 1].$errors.length }}) error found please correct the error to proceed.</span>
                </div>
            </div>
            <a class="btn-close" data-bs-dismiss="alert" aria-label="close"></a>
        </div>

        <form id="create-employee" action="employees/store" class="add-employee add-record">
            <div class="card" v-if="currentStep == 1" title="Personal Information">
                <div class="card-header">
                    <h3 class="card-title">Personal Information</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="row">
                                    <div class="col-7">
                                        <div class="form-label">Given Name</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="given-name"
                                            placeholder="Ex. John"
                                            v-model="step[0].givenName"
                                            :class="{
                                                'is-invalid': v$.step[0].givenName.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].givenName.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="form-label">Preferred Name</div>
                                        <input
                                            type="text"
                                            class="form-control"
                                            name="preferred-name"
                                            placeholder="Ex. Johny"
                                            v-model="step[0].preferredName"
                                            :class="{
                                                'is-invalid': v$.step[0].preferredName.$invalid,
                                            }"
                                        />
                                        <div
                                            class="invalid-feedback"
                                            :class="{
                                                'd-block': v$.step[0].preferredName.$invalid,
                                            }"
                                        >
                                            Invalid feedback
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Surname</div>
                                <input type="text" class="form-control" name="surname" placeholder="Ex. Doe" v-model="step[0].surname" :class="{'is-invalid': v$.step[0].surname.$invalid}" />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].surname.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Email</div>
                                <input type="text" class="form-control" name="email" placeholder="Ex. email@address.com" v-model="step[0].email" :class="{'is-invalid': v$.step[0].email.$invalid}" />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].email.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Date of Birth</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="date-of-birth"
                                    placeholder="01-02-1975"
                                    v-model="step[0].dateOfBirth"
                                    :class="{'is-invalid': v$.step[0].dateOfBirth.$invalid}"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].dateOfBirth.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Place of Birth</div>
                                <input
                                    type="text"
                                    class="form-control"
                                    name="birth-place"
                                    placeholder="Name of city"
                                    v-model="step[0].birthPlace"
                                    :class="{
                                        'is-invalid': v$.step[0].birthPlace.$invalid,
                                    }"
                                />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].birthPlace.$invalid}">Invalid feedback</div>
                            </div>
                        </div>

                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Marital Status</div>
                                <select
                                    class="form-select"
                                    name="marital-status"
                                    v-model="step[0].maritalStatus"
                                    :class="{
                                        'is-invalid': v$.step[0].maritalStatus.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in maritalStatusOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[0].maritalStatus.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Gender</div>
                                <label v-for="option in genderOptions" class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="gender" :value="option" v-model="step[0].gender" />
                                    <span class="form-check-label">{{ option }}</span>
                                </label>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].gender.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Iwi</div>
                                <input type="text" class="form-control" name="iwi" placeholder="Ex. Ngāpuhi" v-model="step[0].iwi" :class="{'is-invalid': v$.step[0].iwi.$invalid}" />
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].iwi.$invalid}">Invalid feedback</div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Ethnicity</div>
                                <select
                                    class="form-select"
                                    name="ethnicity"
                                    v-model="step[0].ethnicity"
                                    :class="{
                                        'is-invalid': v$.step[0].ethnicity.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in ethnicityOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].ethnicity.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].ethnicity === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="ethnicity-other"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].ethnicityOther"
                                        :class="{
                                            'is-invalid': v$.step[0].ethnicityOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].ethnicityOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3">
                                <div class="form-label">Religion</div>
                                <select
                                    class="form-select"
                                    name="religion"
                                    v-model="step[0].religion"
                                    :class="{
                                        'is-invalid': v$.step[0].religion.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in religionOptions" :value="option">
                                        {{ option }}
                                        <span v-if="option === 'Christian'">(Catholic, Protestant & all other Christian denomination)</span>
                                    </option>
                                </select>

                                <div class="invalid-feedback" :class="{'d-block': v$.step[0].religion.$invalid}">Invalid feedback</div>

                                <div v-if="step[0].religion === 'Other'" class="mt-3">
                                    <input
                                        type="text"
                                        class="form-control"
                                        name="religion-other"
                                        placeholder="Other (please specify)"
                                        v-model="step[0].religionOther"
                                        :class="{
                                            'is-invalid': v$.step[0].religionOther.$invalid,
                                        }"
                                    />
                                    <div
                                        class="invalid-feedback"
                                        :class="{
                                            'd-block': v$.step[0].religionOther.$invalid,
                                        }"
                                    >
                                        Invalid feedback
                                    </div>
                                </div>
                            </div>
                            <div class="mb-3" v-if="this.operation == 'update'">
                                <div class="form-label">Profile Photo</div>
                                <div class="d-flex align-items-center">
                                    <span class="avatar avatar-xl rounded-circle" v-bind:style="{backgroundImage: `url('${photo}')`}"></span>
                                    <a :href="editPhotoLink" class="ms-2">Update Photo</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="" id="save-btn d-none">Save and continue later</a>
                    </p>
                    <a href="#" class="btn btn-primary" @click="onClickNext">Next</a>
                </div>
            </div>

            <div class="card" v-if="currentStep == 2" title="Employment Details">
                <div class="card-header">
                    <h3 class="card-title">Employment Details</h3>
                </div>
                <div class="card-body">
                    <div class="row gx-5">
                        <div class="col-sm-10 col-md-8 col-xl-6">
                            <div class="mb-3">
                                <div class="form-label">Date Employed</div>
                                <input
                                    type="date"
                                    class="form-control"
                                    name="date-employed"
                                    placeholder="01-01-1970"
                                    v-model="step[1].dateEmployed"
                                    :class="{
                                        'is-invalid': v$.step[1].dateEmployed.$invalid,
                                    }"
                                />
                                <div
                                    class="invalid-feedback"
                                    :class="{
                                        'd-block': v$.step[1].dateEmployed.$invalid,
                                    }"
                                >
                                    Invalid feedback
                                </div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Role</div>
                                <select
                                    class="form-select"
                                    name="role-id"
                                    v-model="step[1].roleID"
                                    :class="{
                                        'is-invalid': v$.step[1].roleID.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in roleOptions" :value="option.id">
                                        {{ option.name }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].roleID.$invalid}">Invalid feedback</div>
                            </div>

                            <div class="mb-3">
                                <div class="form-label">Status</div>
                                <select
                                    class="form-select"
                                    name="status"
                                    v-model="step[1].status"
                                    :class="{
                                        'is-invalid': v$.step[1].status.$invalid,
                                    }"
                                >
                                    <option value="" disabled>Choose one</option>
                                    <option v-for="option in statusOptions" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div class="invalid-feedback" :class="{'d-block': v$.step[1].status.$invalid}">Invalid feedback</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p class="m-0 text-muted">
                        <a href="#" class="" id="save-btn">Save and continue later</a>
                    </p>
                    <p class="d-flex align-items-center mb-0">
                        <a @click="onClickBack" href="#" class="p-2 mx-3 d-block" id="back-btn">Back</a>
                        <a @click="onClickNext" class="ml-5 btn btn-primary" id="submit-btn">Finish</a>
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import {alpha, alphaNum, email, integer, required, requiredIf, minLength, maxLength, minValue, maxValue, helpers} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";

// Custom Validators
const inArray = (array) => (value) => array.includes(value);
const isDateFormat = (value) => value.match("((?:[0-9]{2})?[0-9]{2})-(1[0-2]|0?[1-9])-(3[01]|[12][0-9]|0?[1-9])");
const isTextWithSpace = (value) => value.match("^[a-zA-Z0-9_ ]*$");
const uniqueEmail =  (value) => {
    const formData = {};
    formData['email'] = value;
    return axios
        .post(location.protocol + "//" + window.location.host + "/api/employees/email-taken/" + process.env.MIX_API_KEY, formData)
        .then((response) => {             
            console.log(response.data);  // The email is unique
            return true;
        })
        .catch((err) => {
            console.log(err.response.data.errors.email[0]);  // The  email is already in use
            return false;
        });
    }

export default {
    name: "employeeCreateComponent",
    props: ["progressBar", "pageTitle", "userId", "employee", "operation", "roles", "photo"], // vue can read kebab props as camel cased vars

    setup() {
        return {v$: useVuelidate()};
    },
    data() {
        var ethnicities = ["European", "Maori", "Pacific Peoples", "Asian", "African", "Middle Eastern", "Latin American", "Other"];
        var religions = ["Buddhist", "Christian", "Hindu", "Jewish", "Muslim", "Sikh", "No religion", "Other"];
        var statuses = ["New", "Permanent", "Resigned", "Volunteer", "Terminated"];
        var roleIDs = [];

        for (const entry of JSON.parse(this.roles)) {
            roleIDs.push(entry.id);
        }

        // If editing, assign employee object to a variable
        if (this.operation == "store") {
            var employeeObject = {};
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/employees/" + process.env.MIX_API_KEY;
        } else if (this.operation == "update") {
            var employeeObject = JSON.parse(this.employee);
            var endpointToUse = location.protocol + "//" + window.location.host + "/api/employees/" + employeeObject.id + "/" + process.env.MIX_API_KEY;
        }

        // Return empty string when object doesn't exist
        // options - array | string
        function returnValueFromObject(fieldName, fieldType, defaultValue = "", options) {
            // Editing
            if (!_.isEmpty(employeeObject)) {
                if (fieldType == "Select With Other") {
                    if (!options.includes(employeeObject[fieldName])) {
                        return "Other";
                    } else {
                        return employeeObject[fieldName];
                    }
                } else if (fieldType == "Timestamp") {
                    employeeObject[fieldName] = employeeObject[fieldName].split(" ")[0]; //get the date only
                    return employeeObject[fieldName];
                } else if (fieldType == "Boolean") {
                    if (employeeObject[fieldName]) {
                        return "Yes";
                    } else {
                        return "No";
                    }
                } else if (fieldType == "JSON") {
                    return JSON.parse(employeeObject[fieldName])[options];
                } else {
                    return employeeObject[fieldName];
                }
            }
            // Creating
            else {
                return defaultValue;
            }
        }

        return {
            currentStep: 1,
            maxStep: 2,
            percentageComplete: 0,
            errors: 0,
            maritalStatusOptions: ["Single", "De Facto", "Married", "Widowed", "Divorced", "Separated"],
            genderOptions: ["Male", "Female"],
            ethnicityOptions: ethnicities,
            religionOptions: religions,
            roleOptions: JSON.parse(this.roles),
            roleIDOptions: roleIDs,
            statusOptions: statuses,
            yesNoOptions: ["Yes", "No"],
            trueFalseOptions: [true, false],
            endpoint: endpointToUse,
            editPhotoLink: "/employees/" + JSON.parse(this.employee).id + "/edit-photo",
            step: [
                // Step 1
                {
                    givenName: returnValueFromObject("first_name"),
                    preferredName: returnValueFromObject("preferred_name"),
                    surname: returnValueFromObject("last_name"),
                    email: returnValueFromObject("email"),
                    
                    dateOfBirth: returnValueFromObject("date_of_birth", "Timestamp", "1975-01-02"), // 1975-01-02 'YYYY-MM-DD' mysql date format  or //new Date().toISOString().slice(0,10)
                    birthPlace: returnValueFromObject("place_of_birth"),
                    maritalStatus: returnValueFromObject("marital_status"),
                    gender: returnValueFromObject("gender"),
                    iwi: returnValueFromObject("iwi"),
                    ethnicity: returnValueFromObject("ethnicity", "Select With Other", "", ethnicities),
                    ethnicityOther: returnValueFromObject("ethnicity", "Select With Other", "", ethnicities) == "Other" ? employeeObject["ethnicity"] : "", // Show the 'other' value
                    religion: returnValueFromObject("religion", "Select With Other", "", religions),
                    religionOther: returnValueFromObject("religion", "Select With Other", "", religions) == "Other" ? employeeObject["religion"] : "", // Show the 'other' value
                },
                // Step 2
                {
                    dateEmployed: returnValueFromObject("date_employed", "Timestamp", new Date().toISOString().slice(0, 10)),
                    roleID: returnValueFromObject("role_id"),
                    status: returnValueFromObject("status"),
                },
            ],
        };
    },
    validations() {
        const dateType = {
            required,
            isDateFormat,
            $lazy: true,
            $autoDirty: true,
        };
        const phoneType = {
            required,
            integer,
            minLength: minLength(10),
            $lazy: true,
            $autoDirty: true,
        };
        const emailType = {
            required,
            email,
            minLength: minLength(5),
            isUnique: helpers.withAsync(uniqueEmail),
            $lazy: true,
            $autoDirty: true,
        };
        const alphaNumType = {
            required,
            alphaNum,
            minLength: minLength(3),
            $lazy: true,
            $autoDirty: true,
        };

        // TEXT TYPES: default: 191, mid:500, long:1000
        function text(minimum = 3, maximum = 191, isRequired = false) {
            var rule = {
                required,
                isTextWithSpace,
                minLength: minLength(minimum),
                maxLength: maxLength(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // INT TYPES:
        function intType(minimum = 0, maximum = 10, isRequired = false) {
            var rule = {
                required,
                integer,
                minValue: minValue(minimum),
                maxValue: maxValue(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // DECIMAL TYPES:
        function decimalType(minimum = 0, maximum = 10, isRequired = false) {
            var rule = {
                required,
                decimal,
                minValue: minValue(minimum),
                maxValue: maxValue(maximum),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // ARRAY TYPES
        function inOptions(options, isRequired = false) {
            var rule = {
                required,
                inOptions: inArray(options),
                $lazy: true,
                $autoDirty: true,
            };

            if (!isRequired) {
                rule = Object.assign({}, rule);
                delete rule["required"];
            }
            return rule;
        }

        // Use for types with no 'required' parameter
        function notRequired(type) {
            var validations = Object.assign({}, type);
            delete validations["required"];

            return validations;
        }

        return {
            step: [
                //Step 1
                {
                    givenName: text(3, 191, true),
                    preferredName: text(3, 191, true),
                    surname: text(3, 191, true),
                    email: emailType,
                    dateOfBirth: dateType,
                    birthPlace: alphaNumType,
                    maritalStatus: inOptions(this.maritalStatusOptions, true),
                    gender: inOptions(this.genderOptions, true),
                    iwi: notRequired(alphaNumType),
                    ethnicity: inOptions(this.ethnicityOptions, true),
                    ethnicityOther: {
                        required: requiredIf(function () {
                            return this.step[0].ethnicity === "Other" ? true : false;
                        }),
                        alpha,
                        minLength: minLength(3),
                        $lazy: true,
                        $autoDirty: true,
                    },
                    religion: inOptions(this.religionOptions, true),
                    religionOther: {
                        required: requiredIf(function () {
                            return this.step[0].religion === "Other" ? true : false;
                        }),
                        alpha,
                        minLength: minLength(3),
                        $lazy: true,
                        $autoDirty: true,
                    },
                },
                //Step 2
                {
                    dateEmployed: dateType,
                    roleID: inOptions(this.roleIDOptions, true),
                    status: inOptions(this.statusOptions, true),
                },
            ],
        };
    },

    computed: {},

    methods: {
        onClickNext: function () {
            // Validate fields on current step
            this.v$.step[this.currentStep - 1].$touch();

            // if there are no errors in the current step
            if (!this.v$.step[this.currentStep - 1].$error) {
                if (this.currentStep < this.maxStep) {
                    // Proceed to next step
                    this.currentStep++;
                } else if (this.currentStep == this.maxStep) {
                    // Initialize alerts and toast notifications for displaying message
                    const toastError = Swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: true,
                    });
                    const alertSuccess = Swal.mixin({
                        position: "center",
                        showConfirmButton: true,
                        timer: 3000,
                        timerProgressBar: true,
                    });

                    // Show button spinner
                    document.getElementById("submit-btn").innerHTML = '<i class="fa fa-circle-notch fa-spin"></i>';
                    document.getElementById("submit-btn").disabled = true;
                    document.getElementById("back-btn").style.display = "none";
                    document.getElementById("save-btn").style.display = "none";

                    // Loop through all fields
                    const formData = {};
                    for (let i = 0; i < this.maxStep; i++) {
                        for (const [key, value] of Object.entries(this.step[i])) {
                            // formData.append(key, value);
                            formData[key] = value;
                        }
                    }

                    // Add userID
                    formData["userID"] = this.userId;

                    if (this.operation == "store") {
                        this.createEmployee(formData, toastError, alertSuccess);
                    } else if (this.operation == "update") {
                        this.updateEmployee(formData, toastError, alertSuccess);
                    }
                }
                this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
            }
        },

        onClickBack: function () {
            if (this.currentStep > 1) {
                this.currentStep--;
            }
            this.percentageComplete = Math.round((this.currentStep / this.maxStep) * 100);
        },

        createEmployee: function (formData, toastError, alertSuccess) {
            // Call the store endpoint
            axios
                .post(this.endpoint, formData)
                .then((response) => {
                    if (response.data.error == 403) {
                        console.log("Bad Request");
                        console.log(response.data);

                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({
                            type: "warning",
                            title: "The input fields are malformed and cant be processed.",
                        });
                    } else {
                        if (response.data.id == null) {
                            console.log("Validation Error");
                            console.log(response.data);

                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the employee object
                            toastError.fire({
                                type: "warning",
                                title: "There are validation errors found on the form.",
                            });
                        } else {
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the employee object was added to the DB. Thi
                            this.formSuccess = true;
                            alertSuccess
                                .fire({
                                    title: "Success!",
                                    text: "The employee has been added.",
                                    icon: "success",
                                })
                                .then(function () {
                                    window.location = "/employees";
                                });
                        }
                    }
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({type: "error", title: "Sorry, request failed to submit."}); // this error occurs when endpoint is wrong
                });
        },

        updateEmployee: function (formData, toastError, alertSuccess) {
            // Call the update endpoint
            axios
                .put(this.endpoint, formData)
                .then((response) => {
                    if (response.data.error == 403) {
                        console.log("Bad Request");
                        console.log(response.data);

                        // Show bad request toast message. This error occurs when the input fields are not in the expected format
                        toastError.fire({
                            type: "warning",
                            title: "The input fields are malformed and cant be processed.",
                        });
                    } else {
                        if (response.data.id == null) {
                            console.log("Validation Error");
                            console.log(response.data);

                            // Show validation toast message. This error only occurs when the javascript validation is bypassed and the API endpoint returned validation error instead of the employee object
                            toastError.fire({
                                type: "warning",
                                title: "There are validation errors found on the form.",
                            });
                        } else {
                            console.log("Success");
                            console.log(response.data);

                            // Show success alert message and redirect to the index page. This occurs when the form submission is successful and the employee object was updated
                            this.formSuccess = true;
                            alertSuccess
                                .fire({
                                    title: "Success!",
                                    text: "The employee has been updated.",
                                    icon: "success",
                                })
                                .then(function () {
                                    window.location = "/employees";
                                });
                        }
                    }
                })
                .catch((err) => {
                    console.log("Endpoint Error!");
                    console.log(err.response);
                    toastError.fire({type: "error", title: "Sorry, request failed to submit."}); // this error occurs when endpoint is wrong
                });
        },
    },
};
</script>
